"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonVariantStyle = void 0;
var getButtonVariantStyle = exports.getButtonVariantStyle = function getButtonVariantStyle(_ref) {
  var variant = _ref.variant,
    color = _ref.color,
    shadow = _ref.shadow;
  return {
    primary: {
      background: color.brandSecondary.gradient,
      boxShadow: shadow.level['04'],
      color: color.neutral['08'],
      ':hover, :focus': {
        boxShadow: shadow.level['02']
      },
      ':active': {
        transition: '0s',
        background: color.brandSecondary.dark
      }
    },
    secondary: {
      background: color.brandPrimary.gradient,
      boxShadow: shadow.level['04'],
      color: color.neutral['08'],
      ':hover, :focus': {
        boxShadow: shadow.level['02']
      },
      ':active': {
        transition: '0s',
        background: color.brandPrimary.light
      }
    },
    outlined: {
      border: "1px solid ".concat(color.brandPrimary.light),
      color: color.brandPrimary.light,
      ':hover, :focus': {
        backgroundColor: color.brandPrimary.light,
        color: color.neutral['08']
      },
      ':active': {
        backgroundColor: color.brandPrimary.medium,
        color: color.neutral['08']
      }
    },
    'outlined-white': {
      border: "1px solid ".concat(color.neutral['08']),
      color: color.neutral['08'],
      ':hover, :focus': {
        backgroundColor: color.neutral['08'],
        color: color.brandPrimary.light
      },
      ':active': {
        backgroundColor: color.line.medium,
        borderColor: color.line.medium,
        color: color.brandPrimary.light
      }
    },
    text: {
      color: color.brandPrimary.light,
      ':hover, :focus': {
        color: color.brandPrimary.medium
      },
      ':active': {
        color: color.brandPrimary.dark
      }
    },
    'text-white': {
      color: color.neutral['08'],
      ':hover, :focus': {
        color: color.neutral['06']
      }
    },
    'secondary-white': {
      backgroundColor: color.neutral['08'],
      boxShadow: shadow.level['03'],
      color: color.brandPrimary.light,
      ':hover, :focus': {
        boxShadow: shadow.level['02']
      },
      ':active': {
        background: color.line.medium
      }
    }
  }[variant];
};